import styles from "./unreadNotificationsModal.module.scss";
import {observer} from "mobx-react-lite";
import {useEffect} from "react";
import Modal from "@components/UI/modal/modal";
import Button from "@components/UI/buttons/button/button";
import useFetching from "@source/hooks/useFetching";
import NotificationController from "@source/api/controllers/notificationController";
import notificationsStore from "@store/notificationsStore";
import userStore from "@store/userStore";

const UnreadNotificationsModal = observer(() => {
  const [getUnreadCount] = useFetching<ReturnType<typeof NotificationController.getUnreadCount>>(NotificationController.getUnreadCount);

  useEffect(() => {
    if (!userStore.getId()) {
      notificationsStore.resetSession();
      return;
    }

    let cancelled = false;

    const loadUnreadCount = async () => {
      const unreadCount = await getUnreadCount();
      if (cancelled || !unreadCount) {
        return;
      }

      notificationsStore.setUnreadCount(unreadCount.count);
      notificationsStore.showUnreadPrompt();
    };

    loadUnreadCount();

    return () => {
      cancelled = true;
    };
  }, [userStore.loggedUser?._id]);

  return (
    <Modal
      open={notificationsStore.unreadPromptOpen}
      close={() => notificationsStore.dismissUnreadPrompt()}
      maxWidth={480}
    >
      <div className={styles.content}>
        <span className={styles.title}>You have unread notifications, check it</span>
        <div className={styles.buttons}>
          <Button
            variant="outlined"
            className={styles.button}
            onClick={() => notificationsStore.dismissUnreadPrompt()}
          >
            Close
          </Button>
          <Button
            className={styles.button}
            onClick={() => notificationsStore.openList()}
          >
            Check
          </Button>
        </div>
      </div>
    </Modal>
  );
});

export default UnreadNotificationsModal;
